import { useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const items = [
  { name: "Sarah Bennett", role: "Founder, Lumen Watches", quote: "Kavion turned our store into a conversion machine. ROAS jumped from 2.1x to 6.8x in 90 days. Their team operates like an extension of ours.", rating: 5 },
  { name: "Marcus Wei", role: "CEO, Aurora Audio", quote: "The redesign alone added $4.2M to our top line. But what set Kavion apart is the rigor — every test, every dashboard, every report.", rating: 5 },
  { name: "Priya Khan", role: "Head of Growth, Stride", quote: "We've worked with five agencies. Kavion is the only one that actually moved the needle. Period.", rating: 5 },
  { name: "Elena Costa", role: "Founder, Verde Skin", quote: "Their CRO system is unreal. Conversion rate doubled in six weeks while ad spend stayed flat.", rating: 5 },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % items.length);
  const prev = () => setI((p) => (p - 1 + items.length) % items.length);

  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="orb top-1/3 left-1/3 w-[600px] h-[600px] bg-indigo-700/15" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Testimonials</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
            Loved by founders<br />who care about <span className="text-gradient">numbers.</span>
          </h2>
        </div>

        <div className="relative glass-heavy rounded-3xl p-8 md:p-14 overflow-hidden">
          <div className="absolute top-6 right-6 flex gap-1">
            {[...Array(items[i].rating)].map((_, k) => (
              <Star key={k} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <p data-testid="testimonial-quote" className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-snug tracking-tight">
            “{items[i].quote}”
          </p>
          <div className="mt-8 flex items-center justify-between">
            <div>
              <div className="font-display font-bold text-white text-lg">{items[i].name}</div>
              <div className="text-sm text-zinc-400">{items[i].role}</div>
            </div>
            <div className="flex gap-2">
              <button data-testid="testimonial-prev" onClick={prev} className="h-11 w-11 rounded-full glass hover:bg-white/10 grid place-items-center transition" aria-label="Previous">
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button data-testid="testimonial-next" onClick={next} className="h-11 w-11 rounded-full bg-white text-black hover:bg-zinc-200 grid place-items-center transition" aria-label="Next">
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {items.map((_, k) => (
            <button
              key={k}
              onClick={() => setI(k)}
              data-testid={`testimonial-dot-${k}`}
              className={`h-1.5 rounded-full transition-all ${k === i ? "w-8 bg-white" : "w-2 bg-white/20"}`}
              aria-label={`Go to testimonial ${k + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
